import { all, takeLatest } from 'lib/redux';
import { LOAD_PITCH_EDITOR_PAGE } from 'constants/ActionTypes';
import loadPitchEditorPageSaga from './PitchEditor.saga';

/**
 * Defines the watchers related to PitchEditor Page.
 * These watchers will be imported in store/RootSaga.js
 */
export default function* watchers() {
  yield all([
    takeLatest(LOAD_PITCH_EDITOR_PAGE, loadPitchEditorPageSaga),
  ]);
}
